<template>
  <div>
    <el-form
      v-if="showPage"
      class="setp-form"
      ref="step1form"
      :rules="rules"
      :model="form"
      label-width="155px"
      size="small"
    >
      <el-form-item label="课题主题" prop="actTitle">
        <el-input
          v-model="form.actTitle"
          style="width: 400px"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="年级" prop="grades">
        <el-select
          v-model="form.grades"
          placeholder="请选择"
          clearable
          multiple
          value-key="grade"
        >
          <el-option
            v-for="item in gradeOptions"
            :key="item.id"
            :label="item.gradeName"
            :value="{ grade: item.grade, gradeName: item.gradeName }"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学科" prop="disciplineCodeList">
        <el-checkbox-group v-model="form.disciplineCodeList">
          <el-checkbox
            v-for="i in disciplineOptions"
            :key="i.id"
            :label="i.disciplineCode"
            >{{ i.disciplineName }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="项目课题研究类型" prop="validatorActive">
        <dic-code-selector
          dicType="topicLevel"
          v-model="form.classify4"
        ></dic-code-selector>
      </el-form-item>
      <el-form-item label="项目课题研究时间" prop="allDate">
        <el-date-picker
          v-model="form.allDate"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="活动环节附件是否可见" prop="isAttachVisible">
        <el-radio-group v-model="form.isAttachVisible">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="主持人">
        <el-input
          v-if="form.actCode"
          v-model="form.createName"
          style="width: 400px"
          disabled
        ></el-input>
        <el-input
          v-else
          v-model="userInfo.userName"
          style="width: 400px"
          disabled
        ></el-input>
      </el-form-item>
      <el-form-item label="主讲人" prop="speakUser">
        <el-button type="text" @click="addSpeakUser">添加本校教师</el-button>
        <br />
        <el-button type="text">添加非本校教师</el-button>
        <el-select
          class="other-select"
          @change="changeKnowledge"
          v-model="form.otherSchoolUsers"
          clearable
          remote
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="非本校教师请输入姓名"
        ></el-select>
        <div class="scorll-list" v-if="form.speakUsers.length > 0">
          <el-tag
            @close="tagSpeakRemove(tag.userId)"
            size="small"
            v-for="tag in form.speakUsers"
            :key="tag.id"
            closable
            >{{ tag.userName }}</el-tag
          >
        </div>
      </el-form-item>
      <el-form-item label="研究背景及依据" prop="actBasis">
        <el-input
          v-model="form.actBasis"
          style="width: 600px"
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入研究背景及依据"
        ></el-input>
      </el-form-item>
      <el-form-item label="研究目标" prop="actPlan">
        <el-input
          v-model="form.actPlan"
          style="width: 600px"
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入研究目标"
        ></el-input>
      </el-form-item>
      <el-form-item label="研究内容" prop="actContent">
        <el-input
          v-model="form.actContent"
          style="width: 600px"
          maxlength="200"
          show-word-limit
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入研究内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="活动内容" prop="contentFormListVal">
        <div
          class="box-active-content"
          v-for="(ci, index) in contentFormList"
          :key="ci.contentId"
        >
          <el-form
            class="content-form"
            ref="contentFormList"
            :model="ci"
            label-width="90px"
            size="small"
          >
            <el-form-item label="活动主题">
              <el-input
                v-model="ci.actTitle"
                style="width: 400px"
                maxlength="20"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-divider></el-divider>
            <el-form-item label="活动时间">
              <el-date-picker
                v-model="ci.allDate"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="活动地点">
              <el-select
                style="width: 150px; margin-right: 10px"
                v-model="ci.orgCode"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in orgOptions"
                  :key="item.orgCode"
                  :label="item.orgName"
                  :value="item.orgCode"
                ></el-option>
              </el-select>
              <el-select
                style="width: 150px; margin-right: 10px"
                v-model="ci.schoolCode"
                placeholder="请选择"
              >
                <el-option
                  v-for="(i, index) in schoolList"
                  :key="index"
                  :label="i.schoolName"
                  :value="i.schoolCode"
                ></el-option>
              </el-select>
              <el-input
                v-model="ci.address"
                style="width: 160px"
                maxlength="9"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="参与教师">
              <el-checkbox-group v-model="ci.joinSchoolCode">
                <el-checkbox
                  v-for="i in schoolList"
                  :key="i.id"
                  :label="i.schoolCode"
                  >{{ i.schoolName }}所有教师</el-checkbox
                >
              </el-checkbox-group>
              <el-checkbox-group v-model="ci.groupCode">
                <el-checkbox
                  v-for="i in groupOptions"
                  :key="i.id"
                  :label="i.groupCode"
                >
                  {{ i.groupName }}
                </el-checkbox>
              </el-checkbox-group>
              <span>
                指定教师
                <el-button type="text" @click="addOtherUser(ci)"
                  >添加</el-button
                >
                <el-button
                  type="text"
                  @click="cancelOtherUser(ci)"
                  v-if="ci.isOtherUers"
                  >取消</el-button
                >
              </span>
              <div class="scorll-list" v-if="ci.joinUsers.length > 0">
                <el-tag
                  @close="tagJoinRemove(ci, tag.userId)"
                  size="small"
                  v-for="tag in ci.joinUsers"
                  :key="tag.id"
                  closable
                  >{{ tag.userName }}</el-tag
                >
              </div>
            </el-form-item>
            <el-form-item label="活动内容">
              <el-input
                v-model="ci.actContent"
                style="width: 480px"
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 8 }"
                maxlength="200"
                show-word-limit
                placeholder="请输入活动内容"
              ></el-input>
            </el-form-item>
            <el-form-item label="活动环节">
              <el-button
                type="plain"
                size="small"
                class="el-icon-plus addlink"
                @click="addLink(ci.contentId)"
                >活动环节</el-button
              >
              <ul class="link-ul">
                <li
                  class="clearfix"
                  v-for="(i, index) in ci.activeNodeTopicForms"
                  :key="i.id"
                >
                  <span class="fl">{{ index + 1 }}</span>
                  <div class="desc fl">
                    <h1>{{ i.topic }}</h1>
                    <h2>
                      <i :class="mapLinkIcon(i.nodeType)"></i>
                      {{
                        nodeList.length > 0
                          ? nodeList.find((item) => item.nodeType == i.nodeType)
                              .nodeDesc
                          : ''
                      }}
                    </h2>
                  </div>
                  <div class="do fr">
                    <!-- <el-button type="text">查看</el-button> -->
                    <el-button type="text" class="edit-but" @click="editLink(i)"
                      >编辑</el-button
                    >
                    <el-button type="text" class="del-but" @click="delLink(i)"
                      >删除</el-button
                    >
                  </div>
                </li>
              </ul>
            </el-form-item>
          </el-form>
          <el-button
            type="plain"
            icon="el-icon-delete"
            class="content-del"
            @click="delContent(ci.contentId)"
          ></el-button>
          <el-button
            v-show="index + 1 == contentFormList.length"
            type="plain"
            icon="el-icon-plus"
            class="content-plus"
            @click="addContent"
          ></el-button>
        </div>
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="addContent"
          >添加子活动</el-button
        >
      </el-form-item>
      <el-form-item label="项目课题研究封面" prop="faceAttaches">
        <face v-model="form.faceAttaches"></face>
      </el-form-item>

      <div>
        <el-button
          :loading="btnLoading"
          class="sub-form"
          size="small"
          @click="submitForm"
          type="primary"
          >发 布</el-button
        >
      </div>
    </el-form>
    <!-- 选择环节弹框 -->
    <el-dialog
      :visible.sync="linkAddPop"
      top="12%"
      width="700px"
      class="link-pop"
    >
      <div class="add-content">
        <h2>添加文档</h2>
        <span
          v-for="i in nodeList.filter((i) => i.classify === 'content')"
          :key="i.nodeType"
          class="clrarfix"
          @click="tabChange(i)"
        >
          <i :class="mapLinkIcon(i.nodeType)"></i>
          <em>{{ i.nodeDesc }}</em>
          <i class="fr el-icon-plus"></i>
        </span>
        <h2>添加互动</h2>
        <span
          v-for="i in nodeList.filter((i) => i.classify === 'interact')"
          :key="i.nodeType"
          class="clrarfix"
          @click="tabChange(i)"
        >
          <i :class="mapLinkIcon(i.nodeType)"></i>
          <em>{{ i.nodeDesc }}</em>
          <i class="fr el-icon-plus"></i>
        </span>
      </div>
    </el-dialog>
    <!-- 指定教师弹框 -->
    <join-pop
      @close="closeJoinPop"
      @joinUsersChange="(users) => joinUserChange(users)"
      :showJoinPop="showJoinPop"
      v-if="showJoinPop"
    ></join-pop>
    <join-pop
      @close="closeSpeakPop"
      @joinUsersChange="speakUserChange"
      :showJoinPop="showSpeakPop"
      v-if="showSpeakPop"
    ></join-pop>
    <div v-loading="!showPage"></div>
  </div>
</template>
<script>
import { mapLinkIcon } from '@/utils/index.js'
import { postData, getData, postJson } from '@/http/fetch.js'
import { mapState, mapGetters } from 'vuex'
import JoinPop from '@/components/common/JoinPop.vue'
import Face from '@/components/common/Face.vue'
import DicCodeSelector from '@/components/common/DicCodeSelector.vue'
export default {
  components: {
    Face,
    JoinPop,
    DicCodeSelector
  },
  computed: {
    ...mapState(['userInfo', 'schoolList', 'topicLink']),
    ...mapGetters(['schoolCodes']),
    orgOptions: function () {
      let orgList = [
        {
          orgCode:
            this.userInfo.teacherSchoolList[0].orgCode ||
            this.userInfo.teacherSchoolList[0].schoolCode,
          orgName:
            this.userInfo.teacherSchoolList[0].orgName ||
            this.userInfo.teacherSchoolList[0].schoolName
        }
      ]
      return orgList
    }
  },
  data() {
    var validatorActiveType = (rule, value, callback) => {
      if (this.form.classify4 === '') {
        return callback(new Error('请完善项目课题研究类型'))
      } else {
        callback()
      }
    }
    var validatorJoinUser = (rule, value, callback) => {
      if (
        this.form.joinUsers.length === 0 &&
        this.form.joinSchoolCode.length === 0
      ) {
        return callback(new Error('请选择参与教师'))
      } else {
        callback()
      }
    }
    var validatorSpeakUser = (rule, value, callback) => {
      if (
        (this.form.speakUsers.length === 0) &
        (this.form.otherSchoolUsers.length === 0)
      ) {
        return callback(new Error('请选择主讲人'))
      } else {
        callback()
      }
    }
    var validatorAllAddress = (rule, value, callback) => {
      if (
        this.form.orgCode == '' ||
        this.form.schoolCode == '' ||
        this.form.address == ''
      ) {
        return callback(new Error('请完善项目课题研究地点'))
      } else {
        callback()
      }
    }
    var validatorContent = (rule, value, callback) => {
      this.contentFormList.forEach((ci, index) => {
        if (
          ci.actTitle === '' ||
          ci.allDate.length === 0 ||
          ci.orgCode === '' ||
          ci.schoolCode === '' ||
          ci.address === '' ||
          ci.actContent === '' ||
          ci.activeNodeTopicForms.length === 0 ||
          (ci.joinSchoolCode.length === 0 &&
            ci.joinUsers.length === 0 &&
            ci.groupCode.length === 0)
        ) {
          return callback(new Error('请完善活动内容的信息 ！'))
        } else if (ci.allDate[1] > this.form.allDate[1]) {
          this.$message({
            message: '活动时间不得大于项目课题研究时间 ！',
            type: 'error',
            duration: 2000,
            offset: 150
          })
          return callback(new Error('活动时间不得大于项目课题研究时间 ！'))
        } else if (index === this.contentFormList.length - 1) {
          //最后一个
          callback()
        }
      })
    }

    return {
      showPage: false,
      btnLoading: false,
      showJoinPop: false, //参与教师
      showSpeakPop: false, //主讲老师弹框
      contentId: '',
      gradeOptions: [],
      disciplineOptions: [],
      groupOptions: [],
      form: {
        actType: 'topic', //教研项目课题研究
        actTitle: '', //项目课题研究主题
        grades: '',
        disciplineCodeList: [],
        disciplineCode: [],
        classify4: '', //活动类型
        allDate: [], //startDate:"",endDate:"",
        startDate: '',
        endDate: '',
        operatorId: '',
        speakUsers: [], //主讲人
        otherSchoolUsers: [],
        actBasis: '', //背景依据
        actPlan: '', //目标
        actContent: '', //内容
        faceAttaches: [], //封面

        orgCode: '', //集团代码
        schoolCode: '', //校区代码
        address: '',
        isAttachVisible: 1,
        subInfoFormList: [] //子活动内容
      },
      rules: {
        actTitle: [
          {
            required: true,
            message: '请输入项目课题研究主题',
            trigger: 'blur'
          }
        ],
        // grades: [{ required: true, message: "请选择年级", trigger: "blur" }],
        // disciplineCodeList: [
        //   { required: true, message: "请选择学科", trigger: "change" }
        // ],
        // validatorActive: [
        //   { validator: validatorActiveType, required: true, trigger: "blur" }
        // ],
        joinUser: [
          { validator: validatorJoinUser, required: true, trigger: 'blur' }
        ],
        speakUser: [
          { validator: validatorSpeakUser, required: true, trigger: 'blur' }
        ],
        allAddress: [
          { validator: validatorAllAddress, required: true, trigger: 'change' }
        ],
        //子活动
        // contentFormListVal: [
        //   { validator: validatorContent, required: true, trigger: "change" }
        // ],
        allDate: [
          {
            required: true,
            message: '请选择项目课题研究时间',
            trigger: 'change'
          }
        ],
        // actContent: [
        //   {
        //     required: true,
        //     message: "请输入项目课题研究内容",
        //     trigger: "blur"
        //   }
        // ],
        // actBasis: [
        //   {
        //     required: true,
        //     message: "请输入项目课题研究背景及依据",
        //     trigger: "blur"
        //   }
        // ],
        // actPlan: [
        //   {
        //     required: true,
        //     message: "请输入项目课题研究目标",
        //     trigger: "blur"
        //   }
        //],
        faceAttaches: [
          { required: true, message: '选择项目课题研究封面', trigger: 'blur' }
        ]
      },
      //子活动内容
      contentFormList: [],
      //环节 弹框
      linkAddPop: false,
      nodeList: [],
      linkFormPop: true
    }
  },
  created() {
    this.init()
  },
  methods: {
    mapLinkIcon,
    async init() {
      this.showPage = false
      await this.getGradeList()
      await this.getDiscipline()
      await this.groupList()
      //回显
      if (sessionStorage.getItem('actCode')) {
        let activeInfo = await getData('/topic/getActiveInfo', {
          actCode: sessionStorage.getItem('actCode'),
          operatorId: this.userInfo.userId
        })
        this.form = { ...activeInfo }
        //封面从资源删除后会没有次字段  导致效验不通过
        if (!activeInfo.faceAttaches) {
          this.$set(this.form, 'faceAttaches', [])
        }
        this.$set(
          this.form,
          'disciplineCodeList',
          activeInfo.disciplines.map((i) => i.disciplineCode)
        )
        this.$set(this.form, 'allDate', [
          activeInfo.startDate,
          activeInfo.endDate
        ])
        //子内容
        activeInfo.subInfoFormList.forEach((ai) => {
          this.$set(ai, 'allDate', [ai.startDate, ai.endDate])
          ai.contentId = ai.id
          ai.joinSchoolCode = JSON.parse(ai.joinSchoolCode)
          ai.groupCode = JSON.parse(ai.groupCode)
          ai.joinUsers = ai.joinUsers || []
        })
        this.contentFormList = activeInfo.subInfoFormList
        //回显环节
        this.initLink(activeInfo.subInfoFormList)
      }
      this.showPage = true
      await this.getNodeList()
    },
    async getNodeList() {
      //得到环节配置
      this.nodeList = await getData('/topic/getSysNodeConfigList')
    },
    async groupList() {

      let { records } = await postJson('/planning/getGroupManagementList', {
        operatorId: this.userInfo.userId,
        pageNum: 1,
        pageSize: -1,
        schoolCodes: this.schoolCodes
      })
      this.groupOptions = records
      return new Promise((resolve) => {
        resolve()
      })
    },
    //添加主讲框
    addSpeakUser() {
      this.showSpeakPop = true
    },
    //关闭添加主讲人弹框
    closeSpeakPop() {
      this.showSpeakPop = false
    },
    //添加主讲教师
    speakUserChange(users) {
      users.forEach((i) => {
        if (
          !this.form.speakUsers.map((item) => item.userId).includes(i.userId)
        ) {
          this.form.speakUsers.push(i)
        }
      })
    },
    //移除主讲人
    tagSpeakRemove(userId) {
      this.form.speakUsers = this.form.speakUsers.filter(
        (i) => i.userId != userId
      )
    },
    ///////////////////////////////////////////////
    //添加指定教师
    addOtherUser(ci) {
      this.contentId = ci.contentId
      this.showJoinPop = true
    },
    //取消指定教师
    cancelOtherUser(ci) {
      ci.joinUsers = []
    },
    //关闭添加弹框
    closeJoinPop() {
      this.showJoinPop = false
    },
    //添加参与教师
    joinUserChange(users) {
      let curContent = this.contentFormList.find(
        (i) => i.contentId == this.contentId
      )
      users.forEach((i) => {
        if (
          !curContent.joinUsers.map((item) => item.userId).includes(i.userId)
        ) {
          curContent.joinUsers.push(i)
        }
      })
    },
    //移除参与教师
    tagJoinRemove(ci, userId) {
      ci.joinUsers = ci.joinUsers.filter((i) => i.userId != userId)
      //强制更新 如果，编辑的时候，没有指定教师 。在添加指定教师后 无法删除。用强制更新。
      this.$forceUpdate()
    },
    async getGradeList() {
      this.gradeOptions = await postData('/school/getGradeList', {
        schoolCode: this.userInfo?.schoolCode
      })
      return new Promise((resolve) => {
        resolve()
      })
    },
    async getDiscipline() {
      this.disciplineOptions = await postData(
        '/discipline/getDisciplinelList',
        {
          schoolCode: this.userInfo?.schoolCode
        }
      )
      return new Promise((resolve) => {
        resolve()
      })
    },
    async submitForm() {
      try {
        this.btnLoading = true
        await this.$refs.step1form.validate()
        //处理子内容
        this.contentFormList.forEach((ci) => {
          ci.startDate = ci.allDate[0]
          ci.endDate = ci.allDate[1]
          // if (ci.joinSchoolCode.length > 0) {
          // 	ci.joinUsers = [];
          // }
          ci.joinSchoolCode = JSON.stringify(ci.joinSchoolCode)
          ci.groupCode = JSON.stringify(ci.groupCode)
        })
        this.form.subInfoFormList = this.contentFormList
        this.form.schoolCode = this.userInfo.schoolCode
        this.form.operatorId = this.userInfo.userId
        if (!this.form.orgCode) {
          this.form.orgCode = this.orgOptions[0].orgCode
        }
        if (!this.form.classify4) {
          this.form.classify4 = -1
        }
        await postJson('/topic/saveOrUpdateActiveInfo', this.form)
        this.btnLoading = false
        this.cleanLink()
        this.$message.success('发布成功！')
        this.$router.push({ name: 'topicResearch' })
      } catch (err) {
        console.log('err', err)
        this.btnLoading = false
      }
    },
    resetForm() {
      this.$refs.step1form.resetFields()
    },
    ///////////////////////////////子内容
    delContent(contentId) {
      this.contentFormList = this.contentFormList.filter(
        (ci) => ci.contentId != contentId
      )
    },
    addContent() {
      let temContent = {
        contentId: new Date().getTime(),
        actTitle: '',
        allDate: [],
        startDate: '',
        endDate: '',
        orgCode: '', //集团代码
        schoolCode: '', //校区代码
        address: '',
        actContent: '',
        joinSchoolCode: [],
        groupCode: [],
        joinUsers: [],
        //环节信息
        activeNodeTopicForms: []
      }
      this.contentFormList.push(temContent)
    },
    ///////////////////////////////环节
    //回显link
    initLink(contentList) {
      let storeLinkList = []
      contentList.forEach((ci) => {
        ci.activeNodeTopicForms &&
          ci.activeNodeTopicForms.forEach((li) => {
            li.contentId = ci.id
            li.tempId = li.id
            storeLinkList.push(li)
          })
      })
      this.$store.commit('initTopicLink', storeLinkList)
    },
    addLink(contentId) {
      this.nodeList.forEach((i) => {
        i.contentId = contentId
      }) //加一个 当前内容的id
      this.linkAddPop = true
    },
    tabChange(info) {
      this.linkAddPop = false
      this.$emit('changTab', 'linkAdd', info)
    },
    cleanLink() {
      this.$store.commit('cleanTopicLink')
    },
    delLink(i) {
      this.$store.commit('delTopicLink', i.tempId)
    },
    editLink(info) {
      this.$emit('changTab', 'linkAdd', info)
    },
    //其他校区主讲人，筛选空值
    changeKnowledge(arr) {
      if (arr.length > 0) {
        if (arr[arr.length - 1].replace(/^\s*|\s*$/g, '').length === 0) {
          this.form.otherSchoolUsers.pop()
        }
      }
    }
  },
  watch: {
    'form.allDate': {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.form.startDate = val[0]
          this.form.endDate = val[1]
        }
      }
    },
    'form.disciplineCodeList': {
      handler(val, oldVal) {
        let temDisciplineCode = []
        this.disciplineOptions.forEach((i) => {
          if (val.includes(i.disciplineCode)) {
            temDisciplineCode.push({
              disciplineCode: i.disciplineCode,
              disciplineName: i.disciplineName
            })
          }
        })
        this.$set(this.form, 'disciplineCode', temDisciplineCode)
      }
    },
    //store 中的topicLink ； 对contentFormList[0].activeNodeTopicForms环节进行赋值
    //contentId 环节中的内容id
    topicLink: {
      handler(val, oldVal) {
        if (val.length === 0) {
          this.contentFormList.forEach((i) =>
            this.$set(i, 'activeNodeTopicForms', [])
          )
        } else {
          this.contentFormList.forEach((i) => {
            if (val.map((vi) => vi.contentId).includes(i.contentId)) {
              this.$set(
                i,
                'activeNodeTopicForms',
                val.filter((svi) => svi.contentId == i.contentId)
              )
            }
          })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.setp-form {
  padding-top: 15px;
  padding-bottom: 30px;
  width: 830px;
  margin: 0 auto;
}

.sub-form {
  margin-top: 30px;
  margin-left: 380px;
}

.scorll-list {
  padding: 2px;
  border: 1px solid rgb(231, 227, 227);
  border-radius: 5px;
  min-height: 30px;
  max-height: 128px;
  overflow: auto;

  .el-tag {
    margin: 3.5px;
    padding: 0px 5px;
  }
}

.box-active-content {
  position: relative;
  left: 0px;
  top: 0px;
  width: 610px;
  margin-top: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid rgb(212, 208, 208);
  padding: 15px 0px;
  padding-bottom: 0px;

  .content-del {
    position: absolute;
    right: -35px;
    top: 0px;
    font-size: 20px;
    padding: 5px;
  }

  .content-plus {
    position: absolute;
    right: -35px;
    top: 35px;
    font-size: 20px;
    padding: 5px;
  }

  .el-divider--horizontal {
    margin: 0px 0px 15px 0px;
  }

  .addlink {
    border: 1px solid @color;
    color: @color;
    padding: 6px 10px;
  }
}

/deep/.link-pop .el-dialog {
  border-radius: 20px;

  .add-content {
    padding: 0px 20px;

    h2 {
      font-size: 17px;
      font-weight: 700;
      margin-bottom: 25px;
    }

    span {
      cursor: pointer;
      vertical-align: middle;
      display: inline-block;
      width: 170px;
      color: @color;
      border-radius: 5px;
      background: #eee;
      padding: 12px 17px;
      font-size: 16px;
      margin-right: 35px;
      margin-bottom: 35px;

      em {
        color: rgb(59, 58, 58);
        margin-left: 15px;
      }

      i {
        vertical-align: middle;
        font-weight: 700;
        font-size: 20px;
      }

      i:nth-of-type(2) {
        font-size: 21px;
      }
    }
  }
}

.link-ul {
  margin-top: 10px;
  padding-left: 0px;

  li {
    border-radius: 8px;
    padding: 0px 10px;
    cursor: pointer;
    border: 1px solid #dfd6d6;

    span {
      margin-top: 13px;
      border: 2px solid @color;
      color: @color;
      height: 28px;
      width: 28px;
      font-size: 20px;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
    }

    .desc {
      h1 {
        font-size: 15px;
        padding-left: 10px;
      }

      h2 {
        margin-top: 0px;
        font-size: 13px;
        height: 22px;
        line-height: 17px;
        padding-left: 10px;
        color: @hui;

        i {
          color: @color;
          font-size: 15px;
        }
      }
    }

    .edit-but {
      margin-left: 100px;
      margin-right: 80px;
      margin-top: 14px;
    }

    .del-but {
      margin-right: 50px;
      color: @hong;
    }
  }
}
</style>
